export { type ControlledSegmentedControlProps, ControlledSegmentedControl } from './ControlledSegmentedControl';

export { type SegmentedControlProps, SegmentedControl } from './SegmentedControl';
